import Vue from 'vue'
import Router from 'vue-router'

// 引导页面
import Home from '@/views/Home'

// mobile
import realme_m from '@/views/mobile/realme'
import starcell_m from '@/views/mobile/starcell'

// pc
import realme from '@/views/pc/realme'
import starcell from '@/views/pc/starcell'
import bolivia_mi from '@/views/pc/bolivia-mi'
import chile_infinix from '@/views/pc/chile-infinix'
import chile_tecno from '@/views/pc/chile-tecno'
import meizu from '@/views/pc/meizu'

Vue.use(Router)

export default new Router({
    // mode:'history',
    routes: [{
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/realme_m',
            name: 'realme_m',
            component: realme_m
        },
        {
            path: '/starcell_m',
            name: 'starcell_m',
            component: starcell_m
        },
        {
            path: '/realme',
            name: 'realme',
            component: realme
        },
        {
            path: '/starcell',
            name: 'starcell',
            component: starcell
        },
        {
            path: '/bolivia_mi',
            name: 'bolivia_mi',
            component: bolivia_mi
        },
        {
            path: '/chile_infinix',
            name: 'chile_infinix',
            component: chile_infinix
        },
        {
            path: '/chile_tecno',
            name: 'chile_tecno',
            component: chile_tecno
        },
        {
            path: '/meizu',
            name: 'meizu',
            component: meizu
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js